import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.section`
  @media ${({ theme }) => theme.device.mobile} {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    background-color: ${({ theme }) => theme.flightDetails.background};
  }
`;

export const Body = styled.section`
  margin: 0 auto;

  @media ${({ theme }) => theme.device.mobile} {
    background: ${ColorPalette.HEX.Cultured};
  }
`;

export const SectionContainer = styled.div`
  padding: 0 15px 15px 15px;
`;
